import React from "react";

import { UserEntityForm, UserFormProps } from "Bands/components";
import { useValidateIssueExpiryDates } from "Bands/utils";
import { getFormFields } from "./formData";

export const UserLoyaltyProgramForm: React.FC<UserFormProps> = ({ defaultValues, ...rest }) => {
  const {
    handleExpiryDateChange,
    handleFutureExpiryDateChange,
    handleIssueDateChange,
    isExpiryInFuture,
    isIssueBeforeExpiry,
  } = useValidateIssueExpiryDates(defaultValues?.issueDate, defaultValues?.expiryDate);

  return (
    <UserEntityForm
      {...rest}
      defaultValues={defaultValues}
      fields={getFormFields({
        isExpiryInFuture,
        isIssueBeforeExpiry,
        handleIssueDateChange,
        handleExpiryDateChange: date => {
          handleExpiryDateChange(date);
          handleFutureExpiryDateChange(date);
        },
      })}
      style={{ gridTemplateColumns: "1fr 1fr" }}
    />
  );
};
